import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MasterService} from './../../home/services/master.service';
import {CommonAlertService} from './../../services/common-alert.service';

@Component({
  selector: 'app-profile-modal',
  templateUrl: './profile-modal.component.html',
  styleUrls: ['./profile-modal.component.scss']
})
export class ProfileModalComponent implements OnInit {

  userData = {
    first_name: '',
    last_name: '',
    email: ''
  };
  successMsg: any;

  // tslint:disable-next-line:max-line-length
  constructor(public masterService: MasterService, public dialogRef: MatDialogRef<ProfileModalComponent>, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
  }

  ngOnInit() {
    this.masterService.getData('/user').subscribe(res => {
      // @ts-ignore
      this.userData = res.user;
    });
  }

  submitForm() {
    // tslint:disable-next-line:variable-name
    const form_data = {};
    Object.assign(form_data, {
      token: localStorage.getItem('token'),
      first_name: this.userData.first_name,
      last_name: this.userData.last_name,
      email: this.userData.email
    });
    this.successMsg = 'Profile Updated Successfully';
    this.masterService.addEditRecord(form_data, '/profile/update_profile_details').subscribe(res => {
      // @ts-ignore
      if (res.success) {
        this.close();
        this.commonAlertService.showEdit({message: this.successMsg});
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

}
